import React from 'react'

import styled from 'styled-components'

// import { IconV2, Skeleton, Typography } from '@/elements'
import {IconV2 } from '../IconV2/index'
import { Skeleton } from '../Skeleton/index'
import { Typography } from '../Typography/index'
import { buttonColors } from './store'
import { Color, Transition } from '@/utils'


const ButtonContainer = styled.button.attrs(
    ({ width, type, disabled, $isRounded }) => ({
        style: { width },
        type,
        disabled,
        'data-rounded': $isRounded ? '' : undefined,
    }),
)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-radius: 3px;
  border-style: solid;
  outline: 0;
  user-select: none;
  transition:
    background ${Transition.fast},
    border-color ${Transition.fast};

  &[data-rounded] {
    border-radius: 100px;
  }

  svg path {
    transition: fill ${Transition.fast};
  }

  &[data-loading] {
    visibility: hidden;
  }

  &:not([disabled]) {
    cursor: pointer;
  }

  &[data-size='small'] {
    min-height: 25px;
    padding: 7px 16px;
    gap: 10px;
  }

  &[data-size='normal'] {
    min-height: 35px;
    padding: 10px 16px;
    gap: 15px;
  }

  &[data-size='big'] {
    min-height: 45px;
    padding: 16px 16px;
    gap: 20px;
  }

  ${Object.keys(buttonColors).map(
    variant => `
      &[data-variant=${variant}] {
        border: none;
        background: ${buttonColors[variant].default};
        border-color: ${buttonColors[variant].default};
        color: ${buttonColors[variant].text || Color.white};
        svg path {
          fill: ${buttonColors[variant].text || Color.white};
        }

        &[data-inverted] {
          background: ${Color.white};
          border-color: ${buttonColors[variant].default};
          color: ${buttonColors[variant].textInverted || buttonColors[variant].default};
          svg path {
            fill: ${
        buttonColors[variant].textInverted ||
        buttonColors[variant].default
    };
          }
        }

        &:hover {
          background: ${buttonColors[variant].hover};
          border-color: ${buttonColors[variant].hover};
          color: ${buttonColors[variant].textHover || Color.white};
          svg path {
            fill: ${buttonColors[variant].textHover || Color.white};
          }
        }

        &:active {
          background: ${buttonColors[variant].active};
          border-color: ${buttonColors[variant].active};
          color: ${buttonColors[variant].textActive || Color.white};
          svg path {
            fill: ${buttonColors[variant].textActive || Color.white};
          }
        }

        &[disabled] {
          background: ${buttonColors[variant].disabled};
          border-color: ${buttonColors[variant].disabled};
          color: ${buttonColors[variant].textDisabled || Color.white};
          svg path {
            fill: ${buttonColors[variant].textDisabled || Color.white};
          }
        }

        &[disabled][data-inverted] {
          background: ${Color.white};
          color: ${buttonColors[variant].disabled};
          svg path {
            fill: ${buttonColors[variant].disabled};
          }
        }
      }
    `,
)}
`


const ButtonV2 = ({
 width,
 variant = 'primary',
 icon,
 inverted = false,
 size = 'normal',
 disabled = false,
 children,
 onClick,
 type,
 dataName,
 loading,
 $isRounded = false,
 refs,
 getReferenceProps,
}) => (
    <ButtonContainer
        data-name={dataName}
        data-size={size}
        ref={refs?.setReference}
        data-variant={variant}
        {...(loading && { 'data-loading': '' })}
        {...(inverted && { 'data-inverted': '' })}
        type={type}
        disabled={disabled}
        width={width}
        $isRounded={$isRounded}
        onClick={() => {
            if (!disabled && typeof onClick === 'function') {
                onClick()
            }
        }}
        {...getReferenceProps}
    >
        {icon && <IconV2 name={icon} />}

        <Typography
            isNoWrap={false}
            color="inherit"
            align="center"
            variant={
                (size === 'small' && 'overline') ||
                (size === 'big' && 'button') ||
                'button'
            }
        >
            {children}
        </Typography>

        {loading && <Skeleton width="100%" height="100%" absolute />}
    </ButtonContainer>
)

export { ButtonV2, buttonColors }
